import cx from "classnames";

import { BREADCRUMB_TITLE_TEXT_CLASS } from "../../../components/BreadcrumbHeaderRoot";

interface ProjectBreadcrumbTitleProps {
  name: string;
  /**
   * Return to the project overview. Because the ticket/review view is local
   * state on the campaign route (not a separate route), this closes an open
   * review so the header title doubles as the "back to project" nav the
   * customer asked for. On the project feed it is a harmless no-op.
   */
  onNavigate: () => void;
}

/**
 * The project name in the workspace header. It is now a clickable link back to
 * the project overview (closing the ticket/review view when one is open) — the
 * previous inline rename affordance moved to the left-nav Recents list so
 * editing lives with the project rows, not "up top". Keeps the `campaign-title`
 * testid so the project page object + tests still resolve the title.
 */
export function ProjectBreadcrumbTitle({
  name,
  onNavigate,
}: ProjectBreadcrumbTitleProps) {
  return (
    <button
      type="button"
      onClick={onNavigate}
      aria-label={`Go to project: ${name}`}
      data-testid="project-breadcrumb-nav"
      className="flex min-w-0 cursor-pointer items-baseline border-none bg-transparent p-0 text-left"
    >
      <span
        className={cx(
          BREADCRUMB_TITLE_TEXT_CLASS,
          "min-w-0 truncate hover:underline",
        )}
        data-testid="campaign-title"
      >
        {name}
      </span>
    </button>
  );
}
